import { useState } from "react";
import { Bot, X, Send, Sparkles } from "lucide-react";

const SOVEREIGN_SUPPORT_URL =
  process.env.REACT_APP_SOVEREIGN_ASSIST_URL || "mailto:support@eigooinc.net";

export default function SovereignAssistant() {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");

  return (
    <>
      <button
        type="button"
        aria-label="Sovereign Assistant"
        data-testid="sovereign-assistant-fab"
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-transform duration-300 hover:scale-110"
        style={{
          background: "linear-gradient(135deg, #F5D87E 0%, #C9A227 50%, #8C7320 100%)",
          boxShadow: "0 8px 32px rgba(201,162,39,0.45), 0 0 0 1px rgba(255,255,255,0.08)",
        }}
      >
        {open ? <X className="w-6 h-6 text-black" /> : <Bot className="w-6 h-6 text-black" />}
      </button>

      {open && (
        <div
          data-testid="sovereign-assistant-panel"
          className="fixed bottom-24 right-6 z-[60] w-[360px] max-w-[calc(100vw-3rem)] rounded-2xl border border-[#C9A227]/40 shadow-2xl overflow-hidden"
          style={{ background: "#0A0A0A" }}
        >
          <div
            className="px-5 py-4 border-b border-[#C9A227]/20 flex items-center gap-2"
            style={{ background: "linear-gradient(180deg, rgba(201,162,39,0.12), transparent)" }}
          >
            <Sparkles className="w-4 h-4 text-[#C9A227]" />
            <div>
              <div className="text-[10px] tracking-armada text-[#C9A227] font-bold">SOVEREIGN ASSISTANT</div>
              <div className="text-sm font-bold text-white">Bridge Officer · Always Listening</div>
            </div>
          </div>
          <div className="p-5 space-y-3">
            <div className="text-sm text-zinc-300 leading-relaxed">
              How can I serve the fleet today, Commander? Type a directive below — it will be
              dispatched to the EIGOO support channel.
            </div>
            <textarea
              data-testid="sovereign-assistant-input"
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              placeholder="Describe what you need…"
              rows={4}
              className="w-full px-3 py-2 rounded-md bg-black/60 border border-white/10 text-white text-sm focus:border-[#C9A227]/60 focus:outline-none resize-none"
            />
            <a
              data-testid="sovereign-assistant-send"
              href={
                SOVEREIGN_SUPPORT_URL.startsWith("mailto:")
                  ? `${SOVEREIGN_SUPPORT_URL}?subject=${encodeURIComponent("Sovereign Directive · Armada SSO")}&body=${encodeURIComponent(msg)}`
                  : SOVEREIGN_SUPPORT_URL
              }
              target={SOVEREIGN_SUPPORT_URL.startsWith("mailto:") ? "_self" : "_blank"}
              rel="noreferrer"
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 rounded-md text-black text-xs font-bold tracking-wider uppercase transition"
              style={{ background: "linear-gradient(135deg, #F5D87E 0%, #C9A227 100%)" }}
            >
              <Send className="w-3.5 h-3.5" />
              Dispatch
            </a>
            <div className="text-[10px] text-zinc-500 leading-relaxed pt-2 border-t border-white/5">
              Tip · Override `REACT_APP_SOVEREIGN_ASSIST_URL` in <code>frontend/.env</code> to
              route to a live AI endpoint (e.g. an LLM webhook).
            </div>
          </div>
        </div>
      )}
    </>
  );
}
